module.exports = __webpack_public_path__ + "img/group_number_grey.a5b8f2a5.svg";